"use strict";
exports.__esModule = true;
var tslib_1 = require("tslib");
var React = tslib_1.__importStar(require("react"));
var style_1 = require("@lyearn/style");
function SvgArrowLeftOutlineLegacy(_props, svgRef) {
    var props = (0, style_1.useSvg)(_props);
    return (React.createElement("svg", tslib_1.__assign({ viewBox: "0 0 24 24", ref: svgRef }, props),
        React.createElement("g", { "data-name": "Layer 2" },
            React.createElement("path", { d: "M13.36 17a1 1 0 01-.72-.31l-3.86-4a1 1 0 010-1.4l4-4a1 1 0 111.42 1.42L10.9 12l3.18 3.3a1 1 0 010 1.41 1 1 0 01-.72.29z", "data-name": "chevron-left" }))));
}
exports["default"] = React.forwardRef(SvgArrowLeftOutlineLegacy);
//# sourceMappingURL=ArrowLeftOutlineLegacy.js.map